import {
  BudgetedHoursCalculationMode,
  BudgetedHoursConfig,
  ProjectTemplate,
  ProjectTemplateApi,
} from 'data/templates/projects';

export const getBudgetedHoursConfigFromTemplate = ({
  templateContent,
  autoBudgetedHours,
}: ProjectTemplateApi | ProjectTemplate): BudgetedHoursConfig | undefined =>
  autoBudgetedHours === true
    ? {
        mode: BudgetedHoursCalculationMode.Auto,
      }
    : templateContent?.budgetedHours != null &&
      (autoBudgetedHours == null || autoBudgetedHours === false)
    ? {
        mode: BudgetedHoursCalculationMode.Manual,
        value: templateContent?.budgetedHours,
      }
    : undefined;
